import HelpPopin from '../components/HelpPopin';
import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

const HelpPage: React.FC = (): React.ReactElement => {
    const { survey_id, uid } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const isManagerFlow = sessionStorage.getItem('isManagerFlow') === 'true';
    const helpVisitedOnMount = useRef(
        sessionStorage.getItem('helpVisited') === 'true',
    );
    const shouldSkip = isManagerFlow && helpVisitedOnMount.current;

    useEffect(() => {
        if (shouldSkip) {
            navigate(`/${survey_id}/${uid}/mandatory-welcome`, {
                state: location.state,
                replace: true,
            });
            return;
        }
        if (isManagerFlow) {
            sessionStorage.setItem('helpVisited', 'true');
        }
    }, []);

    if (shouldSkip) {
        return <></>;
    }

    return (
        <HelpPopin
            permanentPage={true}
            onClose={() => {
                return;
            }}
        />
    );
};

export default HelpPage;
